module.exports = __webpack_public_path__ + "static/media/homepage-video-mobile.40a91c63.mp4";